import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { useToken, navigate, fetchMerchantSubscription } from '../../utility/general';
import { PLANS, SITE } from '../../utility/constants';
import BrandLogo from '../components/brand-logo';
import OnboardingSteps from '../components/onboarding/onboarding-steps';
import OnboardingGetStarted from '../components/onboarding/onboarding-get-started';
import OnboardingAccount from '../components/onboarding/onboarding-account';
import OnboardingReview from '../components/onboarding/onboarding-review';
import OnboardingUser from '../components/onboarding/onboarding-user';
import OnboardingUserConfirmation from '../components/onboarding/onboarding-user-confirmation';
export default (_props) => {
    const token = useToken();
    const [state, mutators] = useStateWithMutators({
        view: {
            currentStep: 0,
            industry: SITE,
            plan: PLANS.Essentials,
            userData: null,
            hasSubscription: null,
            currentPlan: null,
            subscription: null,
            createMSAApplication: false,
        },
        merchantData: null,
        userData: null,
    });
    React.useEffect(() => {
        if (!token)
            return;
        if (!token.merchant) {
            navigate('#/');
            return;
        }
        let cancelled = false;
        fetchMerchantSubscription(token.merchant.id, false).then((subscription) => {
            var _a;
            if (cancelled)
                return;
            mutators.view.subscription(subscription);
            mutators.view.hasSubscription((_a = subscription.has_subscription) !== null && _a !== void 0 ? _a : false);
            mutators.view.currentPlan(subscription.is_updating
                ? subscription.new_plan
                : subscription.subscription_plan);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const handleNavigateToStep = (step) => {
        mutators.view.currentStep(step !== null && step !== void 0 ? step : state.view.currentStep + 1);
    };
    const handleUpdateIndustry = (selectedIndustry) => {
        mutators.view.industry(selectedIndustry);
    };
    const handleUpdateMerchantData = (formData) => {
        mutators.merchantData(formData);
    };
    const handleUpdateUserData = (formData) => {
        mutators.userData(formData);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "row align-items-center g-0 ps-4 pe-3 pt-2 pb-1", children: [_jsx("div", { className: "col-2", children: _jsx("a", { href: "#/", children: _jsx(BrandLogo, { className: "logo-md" }) }) }), _jsx("div", { className: "col-8", children: state.view.currentStep !== 0 && (_jsx(OnboardingSteps, { currentStep: state.view.currentStep })) }), _jsx("div", { className: "col-2" })] }), _jsx("div", { className: "align-items-center justify-content-center mx-3", children: _jsx("div", { className: "container mb-3", children: _jsx("div", { className: "row justify-content-center align-items-center mb-2", children: _jsxs("div", { className: "col-md-8", children: [state.view.currentStep === 0 && (_jsx(OnboardingGetStarted, { currentStep: state.view.currentStep, onNavigateToStep: handleNavigateToStep, onUpdateIndustry: handleUpdateIndustry })), state.view.currentStep === 1 && (_jsx(OnboardingAccount, { industry: state.view.industry, merchantData: state.merchantData, onNavigateToStep: handleNavigateToStep, onUpdateMerchantData: handleUpdateMerchantData })), state.view.currentStep === 2 && (_jsx(OnboardingReview, { merchantData: state.merchantData, onUpdateMerchantData: handleUpdateMerchantData, onNavigateToStep: handleNavigateToStep })), state.view.currentStep === 3 && (_jsx(OnboardingUser, { industry: state.view.industry, currentStep: state.view.currentStep, merchantData: state.merchantData, onNavigateToStep: handleNavigateToStep, onUpdateUserData: handleUpdateUserData })), state.view.currentStep === 4 && _jsx(OnboardingUserConfirmation, {})] }) }) }) })] }));
};
